<template>

                  <div class="other-link">
                    <div v-if="config.superappDownloadUrl!=null && config.superappDownloadUrl!=''" class="download-app">
                      <el-popover
                        placement="left"
                        width="200"
                        trigger="hover"
                        >
                        <img :src="superappDownloadQrCodeImgUrl" width="200" height="200">
                        <span slot="reference" style="display: flex;align-items: center;">
                          <i class="su-icon-qrcode down-loadQrcode" :style="{color:`#${config.schemeColor}`}"></i>
                          <span :style="{color:`#${config.schemeColor}`}">{{i18n["screen.pm.button.downloadapp"]||'下载APP'}}</span>
                        </span>
                      </el-popover>
                    </div>
                    <div v-if="config.activeAccountRedirectUrl!=null && config.activeAccountRedirectUrl!=''"><a :href="activeAccountRedirectUrl" target="_blank" :style="{color:`#${config.schemeColor}`}">{{i18n["screen.pm.button.activeaccount"]||'账号激活'}}</a></div>
                    <div v-if="config.forgotPasswordRedirectUrl!=null && config.forgotPasswordRedirectUrl!=''"><a :href="forgotPasswordRedirectUrl" target="_blank" :style="{color:`#${config.schemeColor}`}">{{i18n["screen.pm.button.forgotpwd"]||'忘记密码？'}}</a></div>
                  </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'superappDownloadQrCodeImgUrl', 

    'forgotPasswordRedirectUrl',
    'activeAccountRedirectUrl',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
